import {createContext, ReactNode, useContext, useEffect, useState} from "react";
import {publishEvent} from "../../../hooks/useEvent";
import {useRPC, useSocket} from "../SocketContext";
import {PlayerDetails} from "../interfaces";
import {rpc_getOnlinePlayerList} from "../rpc";

const Context = createContext<PlayerContextData>(null!);

export default function PlayerContext(props: {children: ReactNode}) {
    const socket = useSocket()

    const [onlinePlayers, setOnlinePlayers] = useState<PlayerDetails[]>([])

    useEffect(() => {
        if (socket.isConnected){
            rpc_getOnlinePlayerList(socket).then(players => {
                if (players){
                    setOnlinePlayers(players)
                }
            })
        }
    }, [socket])

    useRPC(socket, "OnPlayerUpdate", (info: PlayerDetails) => {
        //console.log("OnPlayerUpdate", info)
        
        setOnlinePlayers(currentPlayers => {
            const oldPlayers = currentPlayers.filter(x => x.steamId !== info.steamId)
            
            if (info.isConnected) {
                return [info, ...oldPlayers]
            } else {
                return [...oldPlayers]
            }
        })
        
        publishEvent<PlayerUpdateEvent>("playerUpdate", { player: info })
    })

    useRPC(socket, "OnOnlinePlayersUpdate", (players: PlayerDetails[]) => {
        console.log("OnOnlinePlayersUpdate", players)

        players.forEach(newPlayer => {
            publishEvent<PlayerUpdateEvent>("playerUpdate", { player: newPlayer })
        })

        setOnlinePlayers(players)
    })

    const context: PlayerContextData = {
        online: onlinePlayers,
    }

    return (
        <Context.Provider value={context}>
            {props.children}
        </Context.Provider>
    )
}

export const usePlayers = () => useContext(Context)

interface PlayerContextData{
    online: PlayerDetails[]
}

export interface PlayerUpdateEvent {
    player: PlayerDetails
}